import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { imageSetAvatarThunk } from "../image/imageSetAvatar";
import { ObjectTarget } from "../../app/permissions";

export interface RoutineItemOptionState {
  state: LoadStateInfo;
  selected?: RoutineItemOptionInfo;
}

const initialState: RoutineItemOptionState = {
  state: notStarted(),
};


export interface RetrieveRoutineItemOptionRequest {
  routineItemOptionId: string;
}

export const retrieveRoutineItemOption = createAsyncThunk(
  "retrieveRoutineItemOption",
  async (param: RetrieveRoutineItemOptionRequest, thunkAPI) => {
    console.debug("retrieve routine item option");

    const response = await fetch(`${getBackendUrl()}/api/routine-item-option/${param.routineItemOptionId}`, {
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
      }
    });

    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);


export const routineItemOptionSlice = createSlice({
  name: "routineItemOption",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    select: (state, action: PayloadAction<RoutineItemOptionInfo | undefined>) => {
      console.trace(`select :: ${action.payload?.name}`);
      state.selected = action.payload;
    },
    clean: (state) => {
      state.state = notStarted();
      state.selected = undefined;
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(retrieveRoutineItemOption.pending, (state, /* action */) => {
        state.state =  loading();
        state.selected = undefined;
      })
      .addCase(retrieveRoutineItemOption.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
        state.selected = action.payload;
      })
      .addCase(retrieveRoutineItemOption.rejected, (state, action) => {
        state.state = error(action);
      })
      .addCase(imageSetAvatarThunk.fulfilled, (state, action) => {
        if(state.selected
          && action.meta.arg.objectTarget == ObjectTarget.ROUTINE_ITEM_OPTION
          && action.meta.arg.targetId == state.selected?.id
        ) {
          state.selected.url = action.payload;
        }
      });
    },
});

export interface RoutineItemOptionInfo {
    id: string;
    routineId: string;
    routineItemId: string;
    name: string;
    order?: number;
    color?: number;
    url?: string;
}

// export const { } = routineItemOptionSlice.actions;

export const selectRoutineItemOption = (state: RootState) => state.routineItemOption;

export default routineItemOptionSlice.reducer;
